const AUTH_SESSION_KEY = 'miggus.billing.auth.v1';
const LEGACY_TOKEN_KEY = 'token';

const isStorageAvailable = (storage) => Boolean(storage && typeof storage.getItem === 'function');

const normalizeSession = (value) => {
  if (!value || typeof value !== 'object') return null;

  const idToken = typeof value.idToken === 'string' ? value.idToken.trim() : '';
  if (!idToken) return null;

  return {
    idToken,
    accessToken: typeof value.accessToken === 'string' && value.accessToken.trim() ? value.accessToken : null,
    refreshToken: typeof value.refreshToken === 'string' && value.refreshToken.trim() ? value.refreshToken : null,
    username: typeof value.username === 'string' && value.username.trim() ? value.username.trim() : null,
    source: value.source === 'credentials' ? 'credentials' : 'nonce',
  };
};

export const readAuthSession = (storage = globalThis.sessionStorage) => {
  if (!isStorageAvailable(storage)) return null;

  try {
    const serialized = storage.getItem(AUTH_SESSION_KEY);
    if (!serialized) return null;
    return normalizeSession(JSON.parse(serialized));
  } catch {
    storage.removeItem(AUTH_SESSION_KEY);
    return null;
  }
};

export const saveAuthSession = (session, storage = globalThis.sessionStorage) => {
  if (!isStorageAvailable(storage)) return null;

  const normalized = normalizeSession(session);
  if (!normalized) {
    storage.removeItem(AUTH_SESSION_KEY);
    return null;
  }

  storage.setItem(AUTH_SESSION_KEY, JSON.stringify(normalized));
  return normalized;
};

export const clearAuthSession = (storage = globalThis.sessionStorage) => {
  if (isStorageAvailable(storage)) storage.removeItem(AUTH_SESSION_KEY);
};

export const migrateLegacyAuthSession = ({
  sessionStorage = globalThis.sessionStorage,
  localStorage = globalThis.localStorage,
} = {}) => {
  const current = readAuthSession(sessionStorage);

  if (!isStorageAvailable(localStorage)) return current;

  const legacyToken = localStorage.getItem(LEGACY_TOKEN_KEY)?.trim() || '';
  localStorage.removeItem(LEGACY_TOKEN_KEY);

  if (current || !legacyToken) return current;

  return saveAuthSession({ idToken: legacyToken, source: 'nonce' }, sessionStorage);
};

export const AUTH_STORAGE_KEY = AUTH_SESSION_KEY;
